export default __webpack_public_path__ + "static/media/spinner.adfe5546.gif";